import type { GameState } from "../api";
import { bandCounts, rankOf } from "../../worker/lib/game";
import { closeApp } from "../telegram";

export function ResultSheet({ state, onDismiss }: { state: GameState; onDismiss: () => void }) {
  const won = state.status === "won";
  const bands = bandCounts(state.guesses);
  const title = won ? "Є слово" : "Здався";
  const subtitle = won
    ? `${state.guesses.length} спроб${state.tips ? ` · ${state.tips} підказ.` : ""} · стрік ${state.me.streak} 🔥`
    : `слово було «${state.answer ?? "?"}» · стрік згорів`;
  const others = state.group.filter((g) => g.userId !== undefined);

  return (
    <div className="fixed inset-0 z-30 flex items-end justify-center bg-black/50" onClick={onDismiss}>
      <div
        className="sheet max-h-[88vh] w-full max-w-[520px] overflow-y-auto rounded-t-2xl bg-tgsection px-5 pb-[calc(var(--tg-safe-area-inset-bottom,0px)+20px)] pt-3 text-tgtext shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-tghint/40" />
        <div className="text-center">
          <div className="text-2xl font-bold">{title}</div>
          <div className="mt-1 text-sm text-tghint">{subtitle}</div>
          <div className="mt-3 text-base">
            🟩 {bands.green} &nbsp; 🟨 {bands.yellow} &nbsp; 🟥 {bands.red}
          </div>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-2 text-center">
          <Stat value={state.me.games} label="ігор" />
          <Stat value={state.me.games ? Math.round((state.me.wins / state.me.games) * 100) : 0} label="% розгадано" />
          <Stat value={state.me.streak} label="стрік 🔥" />
          <Stat value={state.me.avgAttempts ?? "–"} label="avg спроб" />
        </div>

        {others.length > 0 && (
          <div className="mt-5">
            <div className="text-xs font-semibold uppercase tracking-wide text-tghint">сьогодні в чаті</div>
            <ul className="mt-2 divide-y divide-tghint/15 text-sm">
              {others.map((g) => (
                <li key={g.userId} className="flex items-center justify-between py-1.5">
                  <span className="font-medium">{g.name}</span>
                  <span className="text-tghint">
                    {g.status === "won"
                      ? `${g.attempts} спроб`
                      : g.status === "gaveup"
                        ? "здався"
                        : `грає… (${g.guessesSoFar}${g.best !== null ? `, найкраще ${rankOf(g.best)}` : ""})`}
                    {g.streak > 0 ? ` · 🔥${g.streak}` : ""}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-5 text-center text-xs text-tghint">чіпс уже несе результат у чат</div>
        <button
          type="button"
          onClick={closeApp}
          className="mt-3 w-full rounded-xl bg-tgbutton py-3 text-sm font-semibold text-tgbuttontext active:opacity-80"
        >
          назад у чат
        </button>
      </div>
    </div>
  );
}

function Stat({ value, label }: { value: number | string; label: string }) {
  return (
    <div>
      <div className="text-2xl font-bold leading-none">{value}</div>
      <div className="mt-1 text-[11px] leading-tight text-tghint">{label}</div>
    </div>
  );
}
